export default __webpack_public_path__ + "static/media/men-career.7b78dccc.jpeg";